import { apiFetch } from './client';

const token = () => localStorage.getItem('token');

export const getPublicEvents = () =>
  apiFetch('/events');

export const getAdminEvents = () =>
  apiFetch('/admin/events', { token: token() });

export const createAdminEvent = (body) =>
  apiFetch('/admin/events', { method: 'POST', token: token(), body });

export const updateAdminEvent = (id, body) =>
  apiFetch(`/admin/events/${id}`, { method: 'PATCH', token: token(), body });

export const deleteAdminEvent = (id) =>
  apiFetch(`/admin/events/${id}`, { method: 'POST', token: token() });
